<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('editProduct') }}</h2>
    <FormProduct :baseProduct="product" @submit-requested="submitRequested"></FormProduct>
  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import FormProduct from '../forms/FormProduct.vue'
import router from '@/router';

  
  export default {  
    data () {
    return {
      product: null
    }
    
  },
  components: { FormProduct },
  computed:{
    ...mapState('products', ['productOutput']),
  },
  methods: {
    ...mapActions('products', ['editProduct']),
    ...mapActions('products', ['getList']),
    submitRequested (product) {
      this.editProduct(product);
    },
  },
  mounted: function()
  {
    // console.log(this.$route.params.product);

    if(!this.$route.params.product)
    {
      router.push({ path: '/products/list' });
    }
    else
    {
      this.product = this.$route.params.product;
    }
  }
}
</script> 
 
<style scoped>
</style> 